export class ApplicationConstants {
    static readonly notSpecified: string = "Not Specified";
}